// extracted by mini-css-extract-plugin
export var askAiIcon = "_mk-9";
export var container = "_mk-0";
export var groupSeparator = "_mk-a";
export var highlight = "_mk-4";
export var resultIcon = "_mk-5";
export var resultItem = "_mk-7";
export var resultSubtitle = "_mk-3";
export var resultTitle = "_mk-2";
export var resultsList = "_mk-1";
export var searchGroup = "_mk-6";
export var selected = "_mk-8";